import { ReactNode } from 'react';

const TextInfoSection = ({
  title,
  info,
}: {
  title: string;
  info: string | ReactNode;
}) => {
  return (
    <div className="space-y-2">
      <div className="font-semibold text-base-text">{title}</div>
      <div className="text-sm text-neutral-700">{info}</div>
    </div>
  );
};

export default TextInfoSection;
